import { routePath } from '~/utils/constants';

const ALLOWED_POST_LOGIN = new Set<string>([
  routePath.admin,
  routePath.latestNews,
]);

export type TAdminLoginLocationState = {
  redirect?: string;
};

/**
 * 從登入頁網址 query 或 router state 取得 redirect（兩者擇一即可）。
 */
export const resolveAdminLoginRedirectParam = (
  search: string,
  locationState: unknown,
): string | null => {
  const fromQuery = new URLSearchParams(search).get('redirect');
  if (fromQuery) {
    return fromQuery;
  }
  const st = locationState as TAdminLoginLocationState | null | undefined;
  return st?.redirect ?? null;
};

/**
 * 後台登入成功後的導向路徑；只允許白名單，避免 open redirect。
 */
export const getSafePostAdminLoginPath = (
  redirect: string | null | undefined,
): string => {
  if (redirect == null || redirect === '') {
    return routePath.admin;
  }
  const path = redirect.trim();
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
    return routePath.admin;
  }
  return ALLOWED_POST_LOGIN.has(path) ? path : routePath.admin;
};
